import { render } from "./MMiniAppAddModal.vue?vue&type=template&id=0587e4b7&scoped=true&ts=true"
import script from "./MMiniAppAddModal.vue?vue&type=script&lang=ts"
export * from "./MMiniAppAddModal.vue?vue&type=script&lang=ts"

import "./MMiniAppAddModal.vue?vue&type=style&index=0&id=0587e4b7&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0587e4b7"]])

export default __exports__